<template>
    <div class="banner">
        <div class="img"></div>
        <div class="title"><h2>{{name}}</h2></div>
        <div class="item"><p class="label"><b>供应商全称</b></p><input type="text" class="text" v-model="form.vendorName" placeholder="请输入您的企业全称"></input></div>
        <div class="item"><p class="label"><b>联系人</b></p><input type="text" class="text" v-model="form.userName" placeholder="请输入您的姓名"></input></div>
        <div class="item"><p class="label"><b>联系方式</b></p><input type="text" class="text" v-model="form.tel" :maxlength="11" placeholder="请输入您的联系方式"></input></div>
        <div class="item">
            <button v-if="!hideButton" class="btn" @click="submit" :disabled="loading">{{loading ? '提交中...' : '提交'}}</button>
            <p class="tips">--- 汇聚全球商机，缔造供需共赢 ---</p>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data () {
        return {
            form: {
                vendorName: '',
                userName: '',
                tel: '',
                sourceName: ''
            },
            name: '',
            loading: false,
            hideButton: false
        };
    },
    methods: {
        remLayout () {
            let w = document.documentElement.clientWidth;
            w = w > 768 ? 768 : w;
            w = w <= 320 ? 320 : w;
            document.documentElement.style.fontSize = w / 10 + 'px';
        },
        submit () {
            let error = false;
            console.log(this.form);
            for (let i in this.form) {
                if (!this.form[i]) {
                    error = true;
                }
            }
            if (error) {
                alert('请把信息填写完整再进行提交');
                return false;
            }
            this.loading = true;
            axios.post('/gscapp/sourceLog/save', {
                ...this.form
            })
            .then((res) => {
                this.loading = false;
                if (res.data.data.code === '1') {
                    alert('报名成功');
                } else {
                    alert(res.data.data.msg);
                }
            })
            .catch(() => {
                this.loading = false;
                alert('网络异常，请联系管理员');
            });
        }
    },
    mounted () {
        this.remLayout();
        window.addEventListener('resize', this.remLayout);
        this.form.sourceName = this.$route.query.sourceId;
        this.name = this.$route.query.name;
        // 过期讯原单号
        let ids = ['RFP00013445', 'RFP00013447', 'RFP00013451', 'RFP00013455', 'RFP00013307', 'RFP00013443', 'RFP00013444', 'RFP00013448', 'RFP00013321', 'RFP00013331'];
        if (ids.includes(this.form.sourceName)) {
            this.hideButton = true;
            alert('寻源已截止，不可报名');
        }
    },
    destroyed () {
        window.removeEventListener('resize', this.remLayout);
        document.documentElement.style = '';
        // 已成功报名，请勿重复报名
    }
};
</script>
<style scoped lang="less">
.banner {
    font-size: .52rem;
    .img {
        height: 4rem;
        background: url('../../../assets/banner10.jpg') no-repeat;
        background-size: 100%;
    }
    .title {
        h2 {
            padding-top: .3rem;
            text-align: center;
            font-size: .6rem;
        }
    }
    .desc {
        padding: .2rem .5rem 0;
    }
    .item {
        padding-top: .3rem;
        text-align: center;
        .text {
            width: 8.5rem;
            padding-left: .2rem;
            height: 1.1rem;
            border-radius: .1rem;;
            font-size: .4rem;
            margin-top: .2rem;
        }
    }
    .btn {
        display: block;
        margin: 0 auto;
        width: 3.5rem;
        height: 1.2rem;
        background: #379adf;
        color: #FFF;
        border-radius: .2rem;
    }
    .tips {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        font-size: .4rem;
    }
}
</style>